const ORIGEN_IMAGE_URL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_popeye-1/artifacts/cy9fq7gr_4982a08d-f494-417c-a52d-2084547b35fc.jpg";

export const Origen = () => {
  return (
    <section
      id="origen"
      data-testid="origen-section"
      className="relative bg-[#0A0A0A] text-white py-16 sm:py-24 border-t border-white/5"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex items-center justify-center gap-3 mb-5">
          <span className="h-px w-10 bg-red-600" />
          <span className="text-[11px] uppercase tracking-[0.35em] text-red-500 font-semibold">
            El Origen de una Tradición
          </span>
          <span className="h-px w-10 bg-red-600" />
        </div>

        <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tighter">
          Chava y <span className="text-red-600">Ricardo</span>
        </h2>
        <p className="mt-4 text-white/75 text-lg sm:text-xl font-light italic">
          Dos hermanos. Una misma pasión.
        </p>

        {/* Foto */}
        <figure className="mt-10 sm:mt-12 flex justify-center">
          <div className="w-full sm:w-[85%] lg:w-[75%]">
            <img
              src={ORIGEN_IMAGE_URL}
              alt="Chava y Ricardo Amaya en Mariscos Popeye 1985"
              data-testid="origen-image"
              loading="lazy"
              className="w-full h-auto rounded-2xl border border-white/10"
            />
          </div>
        </figure>

        {/* Pie de foto */}
        <p className="mt-8 sm:mt-10 text-lg sm:text-xl text-white/90 font-light italic leading-relaxed max-w-3xl mx-auto">
          Chava y Ricardo, unidos por el trabajo, la familia y el amor por los
          mariscos desde hace más de{" "}
          <span className="text-red-500 font-normal not-italic">
            cuatro décadas
          </span>
          .
        </p>
      </div>
    </section>
  );
};
